<template>
  <div class="page-wrap">
    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header__icon">
          <i class="fa fa-tag"></i>
        </div>
        <div class="panel-header__text">
          <div class="panel-header__title">
            {{ isEdit ? 'Edit Abbreviation' : 'Create Abbreviation' }}
          </div>
          <div class="panel-header__sub">Company abbreviation code settings</div>
        </div>
        <div class="panel-header__action">
          <button class="btn-back" @click="goBack()">
            <i class="fa fa-arrow-left"></i> Back
          </button>
        </div>
      </div>

      <!-- Toggle row -->
      <div class="toggle-row">
        <div class="toggle-item">
          <div class="toggle-item__info">
            <span class="toggle-item__label">Show Payment Option</span>
            <span class="toggle-item__hint" v-if="!show_payment_option">
              Disabled — bill to company
            </span>
          </div>
          <label class="toggle-switch">
            <input
              type="checkbox"
              v-model="show_payment_option"
              id="show_payment_option_switch"
            />
            <span class="toggle-switch__track"></span>
          </label>
        </div>
        <div class="toggle-divider"></div>
        <div class="toggle-item">
          <div class="toggle-item__info">
            <span class="toggle-item__label">Active</span>
          </div>
          <label class="toggle-switch">
            <input
              type="checkbox"
              v-model="is_active"
              id="status_switch"
            />
            <span class="toggle-switch__track"></span>
          </label>
        </div>
      </div>

      <!-- Form -->
      <div class="form-section">
        <div class="fields-grid">

          <div class="field-wrap">
            <label class="field-label">Company <span class="req">*</span></label>
            <select
              class="field-select"
              v-model="master_company_id"
              :class="{ 'field-input--error': errors['master_company_id'] }"
            >
              <option value="">Select Company</option>
              <option
                v-for="(item, index) in getMasterCompanies"
                :key="index"
                :value="item.id"
              >{{ item.company_name }}</option>
            </select>
            <span class="field-error" v-if="errors['master_company_id']">
              {{ errors['master_company_id'][0] }}
            </span>
          </div>

          <div class="field-wrap">
            <label class="field-label">Abbreviation Code <span class="req">*</span></label>
            <input
              type="text"
              class="field-input"
              :class="{ 'field-input--error': errors['abbreviation_code'] }"
              v-model="abbreviation_code"
              placeholder="e.g. ACME2024"
            />
            <span class="field-error" v-if="errors['abbreviation_code']">
              {{ errors['abbreviation_code'][0] }}
            </span>
          </div>

          <div class="field-wrap">
            <label class="field-label">Quota <span class="req">*</span></label>
            <input
              type="number"
              min="0"
              class="field-input"
              :class="{ 'field-input--error': errors['quota'] }"
              v-model="quota"
              placeholder="0"
            />
            <span class="field-error" v-if="errors['quota']">
              {{ errors['quota'][0] }}
            </span>
          </div>

          <div class="field-wrap">
            <label class="field-label">Expiration Date Range <span class="req">*</span></label>
            <date-picker
              valueType="MM/DD/YYYY"
              v-model="expireDate"
              format="MM/DD/YYYY"
              :disabled-date="notAfterToday"
              class="date-picker-wrap"
              range
            ></date-picker>
            <span class="field-error" v-if="errors['valid_from']">
              {{ errors['valid_from'][0] }}
            </span>
          </div>

        </div>
      </div>

      <!-- bottom padding for save bar -->
      <div style="height: 72px;"></div>
    </div>

    <!-- Floating save bar -->
    <div class="save-bar">
      <div class="save-bar__left"></div>
      <div class="save-bar__right">
        <button class="save-bar__back" @click="goBack()">
          <i class="fa fa-arrow-left"></i> Back
        </button>
        <button
          v-if="!isEdit"
          class="save-bar__secondary"
          ref="kt_save_add_another_company"
          @click="store('SAA', 'kt_save_add_another_company')"
        >
          <i class="fa fa-plus"></i> Save &amp; Add Another
        </button>
        <button
          v-if="!isEdit"
          class="save-bar__submit"
          ref="kt_save_company"
          @click="store('S', 'kt_save_company')"
        >
          <i class="fa fa-check"></i> Save
        </button>
        <button
          v-if="isEdit"
          class="save-bar__submit"
          ref="kt_update_company_data"
          @click="update('kt_update_company_data')"
        >
          <i class="fa fa-check"></i> Update
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import {
  STORE_COMPANY,
  GET_COMPANY_DATA,
  UPDATE_COMPANY,
  FETCH_MASTER_COMPANIES
} from "@/core/services/store/actions.type";
export default {
  data() {
    return {
      isEdit: false,
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Abbreviations", route: "client.company" },
        { id: 3, title: "Create New Abbreviation", route: "" }
      ],
      company_name: "",
      abbreviation_code: "",
      quota: 1,
      master_company_id: "",
      address: "",
      contact_name: "",
      contact_email: "",
      contact_phone_no: "",
      show_payment_option: false,
      is_active: true,
      expireDate: "",
      errors: []
    };
  },
  computed: {
    ...mapGetters(["getMasterCompanies", "currentUser"])
  },
  created() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.$store.dispatch(FETCH_MASTER_COMPANIES);

    this.isEdit = this.$route.name == "client.company.edit" ? true : false;
    var id = this.$route.params.id;
    if (this.isEdit) {
      this.breadCrumbs[2].title = "";
      this.$store
        .dispatch(GET_COMPANY_DATA, id)
        .then(data => {
          this.breadCrumbs[2].title = "Edit | " + data.company_name;
          this.company_name = data.company_name;
          this.abbreviation_code = data.abbreviation_code;
          this.address = data.address;
          this.contact_name = data.contact_name;
          this.contact_email = data.contact_email;
          this.contact_phone_no = data.contact_phone_number;
          this.is_active = data.is_active;
          this.master_company_id = data.master_company;
          this.quota = data.quota;
          this.show_payment_option = data.show_payment_option;
          this.expireDate = [
            this.$moment(data.valid_from).format("MM/DD/YYYY"),
            this.$moment(data.valid_to).format("MM/DD/YYYY")
          ];
        })
        .catch(() => {
          this.$toastr.e("Company detail not found!");
          this.$router.push({ name: "client.company" });
        });
    }
  },
  methods: {
    notAfterToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    goBack() {
      var client_slug = this.$route.params.client_slug;
      this.$router.push({ name: "client.company", params: { client_slug: client_slug } });
    },
    clearForm() {
      this.quota = 0;
      this.company_name = "";
      this.abbreviation_code = "";
      this.address = "";
      this.contact_name = "";
      this.contact_email = "";
      this.contact_phone_no = "";
      this.master_company_id = "";
      this.is_active = false;
      this.expireDate = "";
      this.show_payment_option = false;
    },
    closeBtnLoad(ref) {
      const submitButton = this.$refs[ref];
      submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
      submitButton.disabled = false;
    },
    loadingButton(ref) {
      const submitButton = this.$refs[ref];
      submitButton.disabled = true;
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
    },
    update(ref) {
      var valid_from = "";
      var valid_to = "";
      this.expireDate = this.expireDate == "," ? "" : this.expireDate;
      if (this.expireDate != "") {
        var exp = this.expireDate;
        valid_from = this.$moment(exp[0]).format("YYYY-MM-DD");
        valid_to = this.$moment(exp[1]).format("YYYY-MM-DD");
      }
      this.errors = [];
      this.loadingButton(ref);
      var data_ = {
        company_name: this.company_name,
        address: this.address,
        abbreviation_code: this.abbreviation_code.replace(/\s/g, ""),
        contact_name: this.contact_name,
        contact_email: this.contact_email,
        contact_phone_number: this.contact_phone_no,
        master_company_id: this.master_company_id,
        is_active: this.is_active,
        quota: this.quota,
        valid_from: valid_from,
        valid_to: valid_to,
        show_payment_option: this.show_payment_option
      };
      this.$store
        .dispatch(UPDATE_COMPANY, { id: this.$route.params.id, data: data_ })
        .then(data => {
          if (data.code == 200) {
            this.$toastr.s(data.msg);
            this.closeBtnLoad(ref);
            this.$router.push({ name: "client.company" });
          } else {
            this.$toastr.w(data.msg);
            this.closeBtnLoad(ref);
          }
        })
        .catch(err => {
          this.errors = err;
          this.closeBtnLoad(ref);
        });
    },
    store(saveType, ref) {
      var valid_from = "";
      var valid_to = "";
      this.expireDate = this.expireDate == "," ? "" : this.expireDate;
      if (this.expireDate != "") {
        var exp = this.expireDate;
        valid_from = this.$moment(exp[0]).format("YYYY-MM-DD");
        valid_to = this.$moment(exp[1]).format("YYYY-MM-DD");
      }
      this.errors = [];
      this.loadingButton(ref);
      var data_ = {
        company_name: this.company_name,
        address: this.address,
        abbreviation_code: this.abbreviation_code.replace(/\s/g, ""),
        quota: this.quota,
        contact_name: this.contact_name,
        contact_email: this.contact_email,
        contact_phone_number: this.contact_phone_no,
        is_active: this.is_active,
        master_company_id: this.master_company_id,
        valid_from: valid_from,
        valid_to: valid_to,
        show_payment_option: this.show_payment_option
      };
      this.$store
        .dispatch(STORE_COMPANY, data_)
        .then(data => {
          this.$toastr.s(data.msg);
          this.closeBtnLoad(ref);
          if (saveType == "S") {
            this.$router.push({ name: "client.company" });
          } else if (saveType == "SAA") {
            this.clearForm();
          }
        })
        .catch(err => {
          this.errors = err;
          this.closeBtnLoad(ref);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$dark:   #0d1b3e;
$green:  #276749;
$border: #dde2ec;

/* ── page ── */
.page-wrap {
  padding: 12px;
  font-family: $font;
  padding-bottom: 100px;
}

/* ── panel card ── */
.panel-card {
  background: #fff;
  border: 1px solid $border;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  max-width: 760px;
  margin: 0 auto;
}

/* ── header ── */
.panel-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid $border;
  background: linear-gradient(135deg, #f8faff 0%, #f0f5ff 100%);

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, $blue, #2277aa);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    flex-shrink: 0;
  }

  &__text { flex: 1; }

  &__title {
    font-size: 16px;
    font-weight: 700;
    color: $dark;
    line-height: 1.2;
  }

  &__sub {
    font-size: 12px;
    color: #7a8499;
    margin-top: 3px;
  }

  &__action { flex-shrink: 0; }
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f0f3fa;
  color: $dark;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  font-family: $font;
  cursor: pointer;
  transition: background 0.15s;

  &:hover { background: #e4eaf5; }
}

/* ── toggle row ── */
.toggle-row {
  display: flex;
  align-items: center;
  gap: 0;
  padding: 16px 24px;
  border-bottom: 1px solid $border;
  background: #fafbfd;
}

.toggle-divider {
  width: 1px;
  height: 36px;
  background: $border;
  margin: 0 24px;
}

.toggle-item {
  display: flex;
  align-items: center;
  gap: 14px;

  &__info {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__label {
    font-size: 13px;
    font-weight: 500;
    color: $dark;
  }

  &__hint {
    font-size: 11px;
    color: #d97706;
  }
}

/* ── toggle switch ── */
.toggle-switch {
  position: relative;
  display: inline-flex;
  cursor: pointer;
  flex-shrink: 0;

  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  &__track {
    display: block;
    width: 40px;
    height: 22px;
    background: #d0d5e0;
    border-radius: 11px;
    transition: background 0.2s;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 3px;
      left: 3px;
      width: 16px;
      height: 16px;
      background: #fff;
      border-radius: 50%;
      transition: transform 0.2s;
      box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    }
  }

  input:checked + &__track {
    background: $blue;
    &::after { transform: translateX(18px); }
  }
}

/* ── form section ── */
.form-section {
  padding: 24px;
}

.fields-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 20px;
}

/* ── fields ── */
.field-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-label {
  font-size: 12px;
  font-weight: 500;
  color: #5a6480;
}

.req { color: #e53935; }

.field-input,
.field-select {
  height: 40px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 13px;
  font-family: $font;
  color: $dark;
  background: #fafbfd;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  width: 100%;

  &::placeholder { color: #b0bac9; }

  &:focus {
    border-color: $blue;
    box-shadow: 0 0 0 3px rgba(56,154,212,0.12);
    background: #fff;
  }

  &--error {
    border-color: #e53935;
    &:focus { box-shadow: 0 0 0 3px rgba(229,57,53,0.1); }
  }
}

.field-select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23a0aab8' d='M1 1l5 5 5-5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-color: #fafbfd;
  padding-right: 28px;
  cursor: pointer;
}

.field-error {
  font-size: 11px;
  color: #e53935;
}

/* date picker override */
.date-picker-wrap {
  width: 100%;

  :deep(.mx-input) {
    height: 40px;
    border: 1.5px solid $border;
    border-radius: 8px;
    font-size: 13px;
    font-family: $font;
    color: $dark;
    background: #fafbfd;
    padding: 0 12px;
    box-shadow: none;
    transition: border-color 0.15s;

    &:focus { border-color: $blue; }
  }
}

/* ── number input: hide spinners ── */
input[type="number"] {
  -moz-appearance: textfield !important;
  appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* ── floating save bar ── */
.save-bar {
  position: fixed;
  bottom: 2.5rem;
  width: calc(78vw);
  left: 50%;
  transform: translateX(-40%);
  background: #1a2340;
  border-radius: 14px;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
  z-index: 200;

  &__left { flex: 1; }

  &__right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__back {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(255,255,255,0.1);
    color: #fff;
    border: 1.5px solid rgba(255,255,255,0.2);
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 500;
    font-family: $font;
    cursor: pointer;
    transition: background 0.15s;

    &:hover { background: rgba(255,255,255,0.18); }
  }

  &__secondary {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(255,255,255,0.12);
    color: #fff;
    border: 1.5px solid rgba(255,255,255,0.25);
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 500;
    font-family: $font;
    cursor: pointer;
    transition: background 0.15s;

    &:hover { background: rgba(255,255,255,0.2); }
  }

  &__submit {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: $blue;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 8px 22px;
    font-size: 13px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    transition: background 0.15s, box-shadow 0.15s;

    &:hover {
      background: #2d85bb;
      box-shadow: 0 4px 14px rgba(56,154,212,0.4);
    }

    &:disabled { opacity: 0.6; cursor: not-allowed; }
  }
}
</style>
